import React from 'react';
import PropTypes from 'prop-types';
import CwTextField from '../cwtextfield/CwTextField';

export const DEFAULT_MASK_STRING = 'ŔĒĀĆŤ';

class CwPasswordField extends React.Component {
  constructor() {
    super();

    this.state = {
      text: DEFAULT_MASK_STRING
    };
  }

  componentDidUpdate() {
    if (this.props.isNew && !this.props.value) {
      // IMPORTANT: unnecessary state update here causes infinite loop
      if (this.state.text !== '') {
        this.setState({
          text: ''
        });
      }
    }
  }

  handleFocus = (event) => {
    event.target.select();
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  handleBlur = () => {
    if (this.props.value !== DEFAULT_MASK_STRING) {
      this.setState({
        text: DEFAULT_MASK_STRING
      });
    }
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  };

  handleChange = (value) => {
    this.setState({
      text: value
    });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  render() {
    return (
      <CwTextField
        {...this.props}
        value={this.state.text}
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        type="password"
      />
    );
  }
}

CwPasswordField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Actual value of password field
   */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  /**
   * Callback function that is fired when textfield's text changes
   */
  onChange: PropTypes.func,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: PropTypes.number,
  /**
   * Used to control if text is valid
   */
  invalid: PropTypes.bool,
  /**
   * Used to disable textfield
   */
  disabled: PropTypes.bool,
  /**
   * Used as an identifier for the component
   */
  id: PropTypes.string,
  /**
   * Callback function that is fired on key down
   */
  onKeyDown: PropTypes.func,
  /**
   * Used to control if passwordfield is autofocused when the page loads
   */
  autoFocus: PropTypes.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func,
  isNew: PropTypes.bool
};

export default CwPasswordField;



// WEBPACK FOOTER //
// ./src/components/cwpasswordfield/CwPasswordField.jsx